export default "__VITE_ASSET__34233bd2__"